<template>
  <router-view v-slot="{ Component }" :key="$route.fullPath">
    <transition
      mode="out-in"
      :enter-active-class="routerTransitionClassIn"
      :leave-active-class="routerTransitionClassOut">
      <component
        :is="Component"
        :key="$route.fullPath"
        :class="routerTransitionClassIn" />
    </transition>
  </router-view>
</template>

<script>
export default {
  props: {
    localeSlug: {
      type: String,
      default: config.locale.defaultLocale,
    },
  },
  data() {
    return {
      enableRouteTransitionAnimation: true,
    };
  },
  computed: {
    shouldAnimateRouter() {
      return this.enableRouteTransitionAnimation && !this.$store.isSaffronHydrating;
    },
    routerTransitionClassIn() {
      return this.shouldAnimateRouter ? config.style.pageTransitionClassIn : "";
    },
    routerTransitionClassOut() {
      return this.shouldAnimateRouter ?
        config.style.pageTransitionClassOut : "";
    },
  },
};
</script>
